<div class="chat-input">
  <ul class="chat-input__attachments" *ngIf="visibleAttachments.length">
    <li
      *ngFor="let item of visibleAttachments; trackBy: trackByAttachmentKey"
      class="chat-input__attachment"
      [class.chat-input__attachment--failed]="isFailed(item)"
    >
      <span class="chat-input__attachment-icon">
        <i [class]="attachmentIcon(item.mime, item.name).className" aria-hidden="true"></i>
      </span>

      <span class="chat-input__attachment-info">
        <span class="chat-input__attachment-name" [title]="item.name">{{ item.name }}</span>

        <span
          class="chat-input__attachment-meta"
          [class.chat-input__attachment-meta--error]="isFailed(item)"
          [title]="item.errorMessage || ''"
        >
          {{ attachmentStatusLabel(item) }}
        </span>

        <span class="chat-input__attachment-progress" *ngIf="isUploading(item)">
          <span
            class="chat-input__attachment-progress-bar"
            [style.width.%]="item.progress"
          ></span>
        </span>
      </span>

      <button
        type="button"
        class="chat-input__attachment-remove"
        (click)="removeAttachment(item)"
        title="Remover"
        aria-label="Remover arquivo"
      >
        <i class="fas fa-times"></i>
      </button>
    </li>
  </ul>

  <div
    class="chat-input__wrapper"
    [class.chat-input__wrapper--dragging]="isDraggingFile"
    (click)="onWrapperClick($event)"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave()"
    (drop)="onDrop($event)"
  >
    <sgt-knowledge-menu
      *ngIf="showKnowledgeMenu"
      [documents]="(documents$ | async) || []"
      [searchQuery]="knowledgeMenuQuery"
      [loading]="(documentsLoading$ | async) || false"
      [truncated]="(documentsTruncated$ | async) || false"
      [limitReached]="!!activeDocument"
      (documentSelected)="onDocumentSelected($event)"
      (closed)="showKnowledgeMenu = false"
    ></sgt-knowledge-menu>

    <div class="chat-input__quick-action" *ngIf="activeQuickAction">
      <i
        class="chat-input__quick-action-icon"
        [ngClass]="activeQuickAction.icon || 'fas fa-bolt'"
      ></i>
      <span class="chat-input__quick-action-title">{{
        activeQuickAction.title
      }}</span>
      <button
        type="button"
        class="chat-input__quick-action-remove"
        aria-label="Remover ação"
        (click)="removeActiveQuickAction()"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>


    <div class="chat-input__input-row">
      <div
        #inputField
        class="chat-input__field"
        contenteditable="true"
        role="textbox"
        [attr.data-placeholder]="activeQuickAction || activeDocument ? '' : placeholder"
        (input)="onInput()"
        (keydown)="onKeydown($event)"
        (paste)="onPaste($event)"
      ></div>
    </div>

    <div class="chat-input__bottom-bar">
      <div class="chat-input__left-actions">
        <input
          #fileInput
          type="file"
          class="chat-input__file-input"
          multiple
          accept=".pdf,.txt,.md,.markdown,.jpg,.jpeg,.png,.gif,.webp,.bmp,.tif,.tiff"
          (change)="onFilesSelected($event)"
        />

        <sgt-composer-menu
          #composerMenu
          [canAttach]="canAttach"
          [canUseActions]="!activeDocument && !hasAttachments"
          [hasConversationFiles]="hasConversationFiles"
          [blockedReason]="attachTooltip"
          (deviceRequested)="openFilePicker()"
          (conversationRequested)="onPickFromConversation()"
          (opened)="onComposerMenuOpened()"
          (actionsRequested)="onActionsRequested()"
          (closed)="onComposerMenuClosed()"
        >
          <sgt-quick-actions-menu
            *ngIf="showQuickActionsMenu && (quickActions$ | async) as quickActions"
            [quickActions]="quickActions"
            [searchQuery]="quickActionsMenuQuery"
            [canGoBack]="true"
            (searchQueryChange)="quickActionsMenuQuery = $event"
            (back)="onActionsBack()"
            (quickActionSelected)="onQuickActionSelected($event)"
            (closed)="closeActions()"
          ></sgt-quick-actions-menu>
        </sgt-composer-menu>
      </div>

      <div class="chat-input__right-actions">
        <span class="chat-input__hint" *ngIf="!canStop">
          Enter envia · Shift+Enter quebra linha
        </span>

        <button
          *ngIf="!canStop"
          type="button"
          class="chat-input__btn chat-input__btn--send"
          [disabled]="sending || !canSend"
          (click)="onSend()"
          title="Enviar"
        >
          <i class="fas fa-arrow-up"></i>
        </button>

        <button
          *ngIf="canStop"
          type="button"
          class="chat-input__btn chat-input__btn--stop"
          [disabled]="isStopping"
          (click)="stopRequested.emit()"
          [title]="isStopping ? 'Parando' : 'Parar'"
        >
          <i [ngClass]="isStopping ? 'fas fa-circle-notch fa-spin' : 'fas fa-stop'"></i>
        </button>
      </div>
    </div>
  </div>
</div>
